module.exports = __webpack_public_path__ + "static/img/1_0_1.c568a35e.jpg";